import { createContext, useContext } from "react";

// The ref-backed check closes synchronously, before React hides private content.
export const NativeSessionGateContext = createContext<() => boolean>(
  () => true
);
export const useCanUseNativeSession = () =>
  useContext(NativeSessionGateContext);

export const NativeSessionReadyContext = createContext(true);
export const useNativeSessionReady = () =>
  useContext(NativeSessionReadyContext);
